/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderProfitEnquiryService = {
  async getBySalesOrderCode(salesOrderCode){
    const requestScreenData = {
      url: "SalesOrderProfitEnquiryList",
      top: "1",
      filter: `SalesOrderCode eq ${salesOrderCode}`,
    };
    let response = await ApiService.oDataGet(requestScreenData);
    let salesOrderEnquiry = response.data[0];
    return salesOrderEnquiry;
  },

  async getQuoteSummaryForSalesOrderCode(salesOrderCode){
    const requestScreenData = {
      url: "SalesQuoteSummary",
      filter: `SalesOrderCode eq ${salesOrderCode}`,
    };
    let response = await ApiService.oDataGet(requestScreenData);
    return response.data;
  },
  
  async getAllQuoteSummaryData(){
    const requestScreenData = {
      url: "SalesQuoteSummary",
    };
    let response = await ApiService.oDataGet(requestScreenData);
    let salesOrderEnquiry = response.data;
    return salesOrderEnquiry;
  },

  async getPurchaseOrderSummaryForSalesOrderCode(salesOrderCode){
    const requestScreenData = {
      url: "SalesOrderEnquiryPurchase",
      filter: `SalesOrderCode eq ${salesOrderCode}`,
    };
    let response = await ApiService.oDataGet(requestScreenData);
    return response.data;
  },
  async getWorkOrderSummaryForSalesOrderCode(salesOrderCode){
    const requestScreenData = {
      url: "SalesOrderProfitEnquiryWOSummary",
      filter: `SalesOrderCode eq ${salesOrderCode}`,
    };
    let response = await ApiService.oDataGet(requestScreenData);
    return response.data;
  },
  async getQuoteDetailForSalesQuoteCode(salesQuoteCode){
    const requestScreenData = {
      url: "SalesQuoteDetail",
      filter: `SalesQuoteCode eq ${salesQuoteCode}`,
    };
    let response = await ApiService.oDataGet(requestScreenData);
    return response.data;
  },
  async getWorkOrderDetailForWorkOrderCode(workOrderCode){
    const requestScreenData = {
      url: "SalesOrderProfitEnquiryWODetail",
      filter: `WorkOrderCode eq ${workOrderCode}`,
    };
    let response = await ApiService.oDataGet(requestScreenData);
    return response.data;
  },

}

export { SalesOrderProfitEnquiryService }
